import { useQuery } from "@apollo/client";
import { useState } from "react";
import { usePath } from "../../contexts/path/path";
import { GET_STATS } from "../../graphql/queries/stats";

const TIME_RANGE_MAP = {
  1: "النصف  الأول",
  2: "النصف الثاني",
};

function useStats() {
  const { category, city, district } = usePath();
  const [statsList, setStatsList] = useState([]);

  const { loading } = useQuery(GET_STATS, {
    skip: !(category?.id && city?.id),
    variables: {
      category: category.id,
      city_id: city.id,
    },
    onCompleted: (res) => {
      const statsValues = res?.Web?.stats?.find(
        (stat) => `${stat.district_id}` === `${district.id}`,
      )?.values;
      statsValues?.slice()?.reverse();
      const valuesMappedList = statsValues?.map((value) => ({
        key: `${TIME_RANGE_MAP[value.time_range.split("-")[0]]}\n${value.year}`,
        value: category === 3 ? value.price * 350 : value.price,
      }));
      setStatsList([...valuesMappedList]);
    },
  });

  return [statsList || [], loading];
}

export default useStats;
